// import 'primeicons/primeicons.css'
// import 'primereact/resources/themes/nova-light/theme.css'
// import 'primereact/resources/primereact.css'
import './css/style.css'

import React, { Component } from 'react'
import { connect } from 'react-redux'
import Modal from 'react-bootstrap/Modal'
import ContactForm from './ContactForm'
import DraggableModalDialog from '../common/DraggableModalDialog'
import { bindActionCreators } from 'redux'
import _ from 'lodash'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { InputText } from 'primereact/inputtext'
import { Button } from 'primereact/button'
import { Dropdown } from 'primereact/dropdown'
import { Calendar } from 'primereact/calendar'
import { MultiSelect } from 'primereact/multiselect'
import { ProgressBar } from 'primereact/progressbar'
import classNames from 'classnames'
import * as instructorActions from '../../_actions/contacts.actions'

class ContactsMng extends Component {
    constructor() {
        super()
        this.state = {
            selectedContact: null,
            globalFilter: null,
            selectedRepresentatives: null,
            dateFilter: null,
            selectedStatus: null,
            show: false,
            delmodal: false,
        }

        //body cells
        this.countryBodyTemplate = this.countryBodyTemplate.bind(this)
        this.representativeBodyTemplate = this.representativeBodyTemplate.bind(
            this
        )
        this.statusBodyTemplate = this.statusBodyTemplate.bind(this)
        this.activityBodyTemplate = this.activityBodyTemplate.bind(this)
        this.actionBodyTemplate = this.actionBodyTemplate.bind(this)

        //filters
        this.representativeItemTemplate = this.representativeItemTemplate.bind(
            this
        )
        this.onRepresentativeFilterChange = this.onRepresentativeFilterChange.bind(
            this
        )
        this.onDateFilterChange = this.onDateFilterChange.bind(this)
        this.filterDate = this.filterDate.bind(this) //custom filter function
        this.statusItemTemplate = this.statusItemTemplate.bind(this)
        this.onStatusFilterChange = this.onStatusFilterChange.bind(this)
    }

    componentDidMount() {
        this.props.actions.fetchContacts()
        this.setState({ mounted: true })
    }

    handleClose = () => {
        this.setState({ show: false })
    }

    handleShow = () => {
        this.setState({ show: true })
    }

    handleDelModalClose = () => {
        this.setState({ delmodal: false })
    }

    handleDelModalShow = () => {
        this.setState({ delmodal: true })
    }

    renderHeader() {
        return (
            <div>
                List of Numbers
                <div className="p-datatable-globalfilter-container">
                    <InputText
                        type="search"
                        onInput={e =>
                            this.setState({ globalFilter: e.target.value })
                        }
                        placeholder="Global Search"
                    />
                </div>
            </div>
        )
    }

    activityBodyTemplate(rowData) {
        return <ProgressBar value={rowData.activity} showValue={false} />
    }

    actionBodyTemplate(rowData) {
        return (
            <div className="btn-toolbar">
                <Button
                    label=""
                    type="button"
                    icon="pi pi-pencil"
                    className="p-button-success p-mr-2"
                    onClick={() => this.rowClick(rowData)}
                    tooltip="Edit"
                    tooltipOptions={{ position: 'bottom' }}
                ></Button>
                <Button
                    label=""
                    type="button"
                    icon="pi pi-trash"
                    className="p-button-warning"
                    onClick={() => this.rowDelete(rowData)}
                    tooltip="Delete"
                    tooltipOptions={{ position: 'bottom' }}
                ></Button>
            </div>
        )
    }

    rowClick = rowData => {
        this.setState({
            selectedContact: rowData,
        })

        this.handleShow()
    }

    rowDelete = rowData => {
        this.setState({
            selectedContact: rowData,
        })
        this.handleDelModalShow()
    }

    statusBodyTemplate(rowData) {
        return (
            <span
                className={classNames(
                    'customer-badge',
                    'status-' + rowData.status
                )}
            >
                {rowData.status}
            </span>
        )
    }

    countryBodyTemplate(rowData) {
        let { name, code } = rowData.country

        return (
            <React.Fragment>
                <span style={{ verticalAlign: 'middle', marginLeft: '.5em' }}>
                    {name}
                </span>
            </React.Fragment>
        )
    }

    representativeBodyTemplate(rowData) {
        const src =
            'showcase/demo/images/avatar/' + rowData.representative.image

        return (
            <React.Fragment>
                <span style={{ verticalAlign: 'middle', marginLeft: '.5em' }}>
                    {rowData.representative.name}
                </span>
            </React.Fragment>
        )
    }

    renderRepresentativeFilter() {
        return (
            <MultiSelect
                className="p-column-filter"
                value={this.state.selectedRepresentatives}
                options={this.state.representatives}
                onChange={this.onRepresentativeFilterChange}
                itemTemplate={this.representativeItemTemplate}
                placeholder="All"
                optionLabel="name"
                optionValue="name"
            />
        )
    }

    representativeItemTemplate(option) {
        const src = 'showcase/demo/images/avatar/' + option.image

        return (
            <div className="p-multiselect-representative-option">
                <img
                    alt={option.name}
                    src={src}
                    srcSet="https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png"
                    width="32"
                    style={{ verticalAlign: 'middle' }}
                />
                <span style={{ verticalAlign: 'middle', marginLeft: '.5em' }}>
                    {option.name}
                </span>
            </div>
        )
    }

    onRepresentativeFilterChange(event) {
        this.dt.filter(event.value, 'representative.name', 'in')
        this.setState({ selectedRepresentatives: event.value })
    }

    renderDateFilter() {
        return (
            <Calendar
                value={this.state.dateFilter}
                onChange={this.onDateFilterChange}
                placeholder="Registration Date"
                dateFormat="yy-mm-dd"
                className="p-column-filter"
            />
        )
    }

    onDateFilterChange(event) {
        if (event.value !== null)
            this.dt.filter(this.formatDate(event.value), 'date', 'equals')
        else this.dt.filter(null, 'date', 'equals')

        this.setState({ dateFilter: event.value })
    }

    filterDate(value, filter) {
        if (
            filter === undefined ||
            filter === null ||
            (typeof filter === 'string' && filter.trim() === '')
        ) {
            return true
        }

        if (value === undefined || value === null) {
            return false
        }

        return value === this.formatDate(filter)
    }

    formatDate(date) {
        let month = date.getMonth() + 1
        let day = date.getDate()

        if (month < 10) {
            month = '0' + month
        }

        if (day < 10) {
            day = '0' + day
        }

        return date.getFullYear() + '-' + month + '-' + day
    }

    renderStatusFilter() {
        return (
            <Dropdown
                value={this.state.selectedStatus}
                options={this.state.statuses}
                onChange={this.onStatusFilterChange}
                itemTemplate={this.statusItemTemplate}
                showClear={true}
                placeholder="Select a Status"
                className="p-column-filter"
            />
        )
    }

    statusItemTemplate(option) {
        return (
            <span className={classNames('customer-badge', 'status-' + option)}>
                {option}
            </span>
        )
    }

    onStatusFilterChange(event) {
        this.dt.filter(event.value, 'status', 'equals')
        this.setState({ selectedStatus: event.value })
    }

    newContact = () => {
        this.setState({
            selectedContact: {},
        })
        this.handleShow()
    }

    remove = event => {
        const id = this.state.selectedContact.id
        this.props.actions
            .removeContactById(id)
            .then(res => this.handleDelModalClose())
            .catch(error => {
                console.log(`error=${error}`)
            })
    }

    render() {
        const numbers = _.map(this.props.contacts, (obj, key) => {
            return obj
        })

        const header = this.renderHeader()

        return (
            <div className="row">
                <div className="col-sm-12 col-md-12">
                    <div className="panel">
                        <div className="panel-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12 col-md-12 content-section">
                                        <Button
                                            label="Add
                                         Contact"
                                            type="button"
                                            icon="pi pi-plus"
                                            className="p-button-primary p-button-raised"
                                            onClick={this.newContact}
                                        ></Button>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-12 col-md-12">
                                        <div className="datatable-doc-demo">
                                            <DataTable
                                                ref={el => (this.dt = el)}
                                                value={numbers}
                                                header={header}
                                                className="p-datatable-customers"
                                                dataKey="id"
                                                rowHover
                                                globalFilter={
                                                    this.state.globalFilter
                                                }
                                                selection={
                                                    this.state.selectedContact
                                                }
                                                onSelectionChange={e =>
                                                    this.setState({
                                                        selectedContact:
                                                            e.value,
                                                    })
                                                }
                                                paginator
                                                rows={10}
                                                emptyMessage="No numbers found"
                                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                                rowsPerPageOptions={[
                                                    10,
                                                    25,
                                                    50,
                                                ]}
                                            >
                                                <Column
                                                    field="firstName"
                                                    header="FirstName"
                                                    sortable
                                                />
                                                <Column
                                                    field="lastName"
                                                    header="LastName"
                                                    sortable
                                                />
                                                <Column
                                                    field="mobile"
                                                    header="Mobile"
                                                    sortable
                                                />
                                                {/* <Column
                                                    field="address"
                                                    header="Address"
                                                    sortable
                                                />
                                                <Column
                                                    field="email"
                                                    header="Email"
                                                    sortable
                                                /> */}
                                                <Column
                                                    field="group"
                                                    header="Group"
                                                    sortable
                                                />
                                                
                                                {/* <Column
                                                    field="enable"
                                                    header="Status"
                                                    sortable
                                                /> */}
                                                <Column
                                                    body={
                                                        this.actionBodyTemplate
                                                    }
                                                    headerStyle={{
                                                        width: '10em',
                                                        textAlign: 'center',
                                                    }}
                                                    bodyStyle={{
                                                        textAlign: 'center',
                                                        overflow: 'visible',
                                                    }}
                                                />
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Modal
                    dialogComponentClass={DraggableModalDialog}
                    dialogClassName="mod-w450"
                    show={this.state.show}
                    onHide={this.handleClose}
                >
                    <div>
                        <div>
                            <Modal.Header closeButton>
                                <Modal.Title>Contact</Modal.Title>
                            </Modal.Header>
                            <ContactForm
                                handleClose={this.handleClose.bind(this)}
                                data={this.state.selectedContact}
                                actions={this.props.actions}
                            />
                        </div>
                    </div>
                </Modal>

                <div className="modal-sm">
                    <Modal
                        show={this.state.delmodal}
                        onHide={this.handleDelModalClose}
                        dialogClassName="mod-w400"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>
                                <span>Confirm Delete</span>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <span>Are you sure?</span>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-success pull-left btn-sm-w"
                                    onClick={this.remove}
                                >
                                    Yes
                                </button>

                                <button
                                    type="submit"
                                    className="btn btn-default btn-sm-w"
                                    onClick={this.handleDelModalClose}
                                >
                                    No
                                </button>
                            </div>
                        </Modal.Body>
                    </Modal>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        contacts: state.contacts.contacts,
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(instructorActions, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactsMng)
